import React, { useEffect, useState, useRef } from 'react';
import { useSelector } from "react-redux";
import classNames from "classnames";
import LazyLoadImageComponent from "common/components/LazyLoadImage";
import isMobile from 'common/helpers/isMobile';
import Session from "../../available-sessions-modal/components/Session";
import { func, string, object } from 'prop-types';
import {getProductToAnalytics} from "../../cart/components/Cart";
const pg_type = window.drupalSettings && window.drupalSettings.pg_type || '';

const ModalSessions = ({
  t,
  selectedSession,
  onCloseModal,
  selectedItem,
  actions,
  sessionId,
  type,
  sessionSubtitle,
  productTitle,
  currencyCode,
  itemListName,
}) => {
  const imageRef = useRef();
  const state = useSelector((state) => state);
  const [currentSession, setCurrentSession] = useState({id: null, date: null, time: null});
  const [sessionsHeight, setSessionsHeight] = useState(0);

  const {
    availableSessions: modalData,
    cart: cartData,
  } = state;

  const handleResize = () => {
    const windowHeight = window.innerHeight;
    // 100px - padding, margin and title height
    const sessionHeight = windowHeight - imageRef.current.clientHeight - 100;
    setSessionsHeight(isMobile ? sessionHeight : 0);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize, false);
  }, []);

  useEffect(() => {
    const selected = modalData.sessions.find((el) => el.id === selectedSession);
    if (selected) {
      const { id, date, time } = selected;
      setCurrentSession({id, date, time});
    }
    handleResize();
  }, [modalData]);

  const onChangeCartItem = (e) => {
    e.preventDefault();
    actions.cart.onUpdateSession(selectedItem.id, currentSession, type, sessionId);
    actions.cart.fetch().then(() => {
      const item = cartData[type][sessionId];
      let products = [];
      let productObj = getProductToAnalytics(item);

      products.push(productObj);

      window.dataLayer &&
      window.dataLayer.push({
        event: "change_now",
        ecommerce: {
          currency: currencyCode,
          items: products,
        }
      });
      onCloseModal();
    });
  };

  return (
    <div className={classNames(`new-sessions`, {
      "available-sessions--mobile": isMobile
    })}>
      <div className="available-sessions__image" ref={imageRef}>
        <LazyLoadImageComponent
          src={modalData.image.uri}
          alt={modalData.image.alt}
        />
      </div>
      <div className="available-sessions__body">
        <div className="available-sessions__header">
          <span className="available-sessions__category" style={{backgroundColor: modalData.color}}>
            {modalData.category}
          </span>
          <div className="available-sessions__header-inner">
            <div className="available-sessions__header-inner-left">
              <h2 className='available-sessions__title'>
                {productTitle ? productTitle : modalData.title}
              </h2>
              {!isMobile && !sessionSubtitle && (
                <p className="available-sessions__desk">
                  {modalData.description}
                </p>
              )}
              <h3 className='available-sessions__subtitle'>
                {sessionSubtitle}
              </h3>
            </div>
            {!isMobile && (
              <a className='available-sessions__cta' href={modalData.cta.url}>{modalData.cta.label}</a>
            )}
          </div>
          {!sessionSubtitle && (
            <span className='available-sessions__price'>
            {modalData.price_string}
          </span>
          )}
        </div>
        <div className="available-sessions__list" >
          {modalData.sessions.length > 0 && (
            <span className="available-sessions__list-select-session">{t('Select a session', DT_SESSIONS)}</span>
          )}
          <span className="available-sessions__list-title">
            {modalData.sessions_available_label}
          </span>
          <div className="available-sessions__list-inner" style={{ minHeight: sessionsHeight }}>
            {modalData.sessions.map((item) => (
              <Session setCurrentSession={setCurrentSession} currentSession={currentSession} key={item.id} {...item}/>
            ))}
          </div>
        </div>
        {currentSession.id !== null && (
          <a href="#" onClick={onChangeCartItem} className='available-sessions__submit'>
            {t('Confirm', DT_SESSIONS)}
          </a>
        )}
      </div>
    </div>
  );
};

ModalSessions.propTypes = {
  t: func.isRequired,
  selectedSession: string.isRequired,
  onCloseModal: func.isRequired,
  selectedItem: object.isRequired,
  sessionId: string.isRequired,
  actions: object.isRequired,
  type: string.isRequired,
  currencyCode: string.isRequired,
};

export default ModalSessions;
